/**
 * Created by qlong on 10/3/2016.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { addChart } from '../actions/filteredLineChartActions'
import LineChart from '../components/Highcharts/LineChart'
import { changeIndicator } from '../actions/filteredLineChartActions'


@connect((store) => {
    return{
        filteredLineChart: store.filteredLineChart,
        fileData: store.fileData,
    }
})
export default class FilterLineChart extends Component {
    shouldComponentUpdate(nextProps){
        return nextProps.filteredLineChart.shouldComponentUpdate
    }

    componentDidUpdate (){
        if (this.props.filteredLineChart.shouldComponentUpdate){
            const chart = this.refs.highChart.refs.hc.getChart()
            this.props.dispatch(addChart(chart))
            this.props.dispatch(changeIndicator(false))
        }
    }

    render(){
        const { chartData } = this.props.fileData
        if (chartData != null && Object.keys(chartData).length > 0) {
            return(
                <LineChart ref="highChart" data={chartData}  />
            )
        } else {
            return (<div></div>)
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/containers/FilteredLineChart.js
 **/